<template>
  <div
    class="sticky top-0 z-[1000000] h-16 w-full flex items-center justify-center border-b"
    :style="{background: 'linear-gradient(90deg, #1b83f5 0%, #195FC8 100%)'}"
  >
    <div
      class="text-white text-sm h-12 pl-3 pr-2 flex items-center justify-between rounded shadow-[inset_0_2px_4px_rgba(0,0,0,0.25)]"
      :style="{
        backgroundColor: '#195FC8',
        dropShadow: '0px 1px 0px #1b83f5'
      }"
    >
      <div class="inline-flex items-center justify-center">
        <img
          src="@/assets/images/estage-3d.png"
          class="w-8 h-8 mr-2"
        >
        Want to Get Full Access to <b class="ml-1">All Estage Features?</b>
      </div>

      <b-btn
        variant="white"
        size="md"
        class="ml-4 !rounded !text-black"
        @click="toSignup"
      >
        Get Started - <b>Signup Today</b>
      </b-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpgradePlanBar',
  methods: {
    toSignup () {
      this.$router.push('/signup')
    }
  }
}
</script>